module.exports = __webpack_public_path__ + "static/media/stars white.75359ce8.svg";